module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevi",
      "title": "vi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("I am poured out like water, "), _c('br'), _vm._v("and all my bones are out of joint; "), _c('br'), _vm._v("my heart is like wax; "), _c('br'), _vm._v("it is melted within my breast.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Psalm+22%3A14&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Psalm 22:14")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd12d1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_epigraph.vue
// module id = 63
// module chunks = 0